"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSlider = void 0;
var _react = require("react");
var _emblaCarouselReact = _interopRequireDefault(require("embla-carousel-react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var useSlider = function useSlider(locale, options) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPrevButtonEnabled = _useState2[0],
    setIsPrevButtonEnabled = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNextButtonEnabled = _useState4[0],
    setIsNextButtonEnabled = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeSlideIndex = _useState6[0],
    setActiveSlideIndex = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    scrollSnaps = _useState8[0],
    setScrollSnaps = _useState8[1];
  var isRtl = locale === "ar-ae";
  var _useEmblaCarousel = (0, _emblaCarouselReact.default)(_objectSpread(_objectSpread({}, options), {}, {
      direction: isRtl ? "rtl" : "ltr"
    })),
    _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
    sliderRef = _useEmblaCarousel2[0],
    emblaAPI = _useEmblaCarousel2[1];
  var goToPrevious = (0, _react.useCallback)(function () {
    return emblaAPI === null || emblaAPI === void 0 ? void 0 : emblaAPI.scrollPrev();
  }, [emblaAPI]);
  var goToNext = (0, _react.useCallback)(function () {
    return emblaAPI === null || emblaAPI === void 0 ? void 0 : emblaAPI.scrollNext();
  }, [emblaAPI]);
  var goTo = (0, _react.useCallback)(function (index) {
    return emblaAPI === null || emblaAPI === void 0 ? void 0 : emblaAPI.scrollTo(index);
  }, [emblaAPI]);
  var onSelect = (0, _react.useCallback)(function () {
    if (!emblaAPI) return;
    setActiveSlideIndex(emblaAPI.selectedScrollSnap());
    setIsPrevButtonEnabled(emblaAPI.canScrollPrev());
    setIsNextButtonEnabled(emblaAPI.canScrollNext());
  }, [emblaAPI]);
  (0, _react.useEffect)(function () {
    if (!emblaAPI) return;
    onSelect();
    setScrollSnaps(emblaAPI.scrollSnapList());
    emblaAPI.on("select", onSelect);
    return function () {
      emblaAPI.off("select", onSelect);
    };
  }, [emblaAPI, onSelect]);
  return {
    sliderRef: sliderRef,
    emblaAPI: emblaAPI,
    data: {
      isPrevButtonEnabled: isPrevButtonEnabled,
      isNextButtonEnabled: isNextButtonEnabled,
      activeSlideIndex: activeSlideIndex,
      scrollSnaps: scrollSnaps
    },
    actions: {
      goToPrevious: goToPrevious,
      goToNext: goToNext,
      goTo: goTo
    }
  };
};
exports.useSlider = useSlider;